"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

// Source: /frontend/js/src/preact-components/assets/icon-bell-notifications.tsx
var BellNotifications = function BellNotifications(props) {
  return (0, _preact.h)("svg", (0, _extends2.default)({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 16 16",
    fill: "none",
    role: "img",
    "aria-hidden": "true",
    focusable: "false"
  }, props), (0, _preact.h)("g", {
    clipPath: "url(#clip0_3052_5460)"
  }, (0, _preact.h)("path", {
    d: "M8.00008 14.0001C8.73341 14.0001 9.33341 13.4001 9.33341 12.6667H6.66675C6.66675 13.4001 7.26675 14.0001 8.00008 14.0001ZM12.0001 9.66669V7.33335C12.0001 5.28669 10.9134 3.57335 9.00008 3.12002V3.00006C9.00008 2.44673 8.55341 2.00006 8.00008 2.00006C7.44675 2.00006 7.00008 2.44673 7.00008 3.00006V3.12002C5.09341 3.57335 4.00008 5.28002 4.00008 7.33335V9.66669L3 11.3334V12.0001H13V11.3334L12.0001 9.66669ZM10.6667 10.6667H5.33341V7.33335C5.33341 5.68002 6.34008 4.33335 8.00008 4.33335C9.66008 4.33335 10.6667 5.68002 10.6667 7.33335V10.6667Z",
    fill: "#2B3346"
  })), (0, _preact.h)("defs", null, (0, _preact.h)("clipPath", {
    id: "clip0_3052_5460"
  }, (0, _preact.h)("rect", {
    width: "24",
    height: "24",
    fill: "white"
  }))));
};

var _default = BellNotifications;
exports.default = _default;